import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustedBy from './components/TrustedBy';
import About from './components/About';
// import Work from './components/Work'; // Commented out - ready to restore
import CaseStudies from './components/CaseStudies';
import Research from './components/Research';
// import Media from './components/Media'; // Commented out - ready to restore
// import Speaking from './components/Speaking'; // Commented out - ready to restore
import Contact from './components/Contact';
import Footer from './components/Footer';
import DarkModeToggle from './components/DarkModeToggle';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved theme preference or default to light mode
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    
    if (newMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <div className="min-h-screen bg-surface-white dark:bg-primary-navy transition-colors duration-300 overflow-x-hidden">
      <Navbar />
      <DarkModeToggle isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      
      <main>
        <Hero />
        <TrustedBy />
        <About />
        {/* <Work /> */}
        <CaseStudies />
        <Research />
        {/* <Media /> */}
        {/* <Speaking /> */} {/* Commented out as requested - ready to restore */}
        <Contact />
      </main>
      
      <Footer />
    </div>
  );
}

export default App;
